import Seo from "../components/common/Seo";
import PageHeader from "../components/common/PageHeader";
import IndustriesGrid from "../components/sections/IndustriesGrid";
import FinalCTA from "../components/sections/FinalCTA";
import { complianceLine } from "../lib/content";

export default function Industries() {
  return (
    <>
      <Seo
        title="Industries — Kratos Venture Group"
        description="Solutions configured for automotive, professional services, real estate, finance, construction, logistics, hospitality, retail, and manufacturing."
        path="/industries"
      />
      <PageHeader
        eyebrow="Industries"
        title="Built around the way your sector operates."
        intro={complianceLine}
      />
      <IndustriesGrid showHeading={false} />
      <FinalCTA />
    </>
  );
}
